import React, { useState, useEffect, useRef, useMemo } from "react";
import { Box, BreadcrumbGroup, Button, Container, Grid, Icon, Input, SpaceBetween, Spinner, StatusIndicator } from "@amzn/awsui-components-react";
import aiInsights from '../../../images/aiInsights.svg'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { convertToLocalTime } from "src/Ateam-BI/CorpReporting/Utility";
import { getResultContent } from "../Utility";


const FirstPassResultComponent = (props) => {
  const [viewResultsRequestDetails, setViewResultsRequestDetails] = useState(null)
  const [isResultsLoading, setIsResultsLoading] = useState(false);


  useEffect(() => {
    if(props?.data){
      loadView()
    }
    
  }, [props]);

  const loadView = () => {
   fetchDetails(props.data)
  }

  const fetchDetails = async (data) => {
    setIsResultsLoading(true)
    let htmlData = await getResultContent(data)
    data['markdownData'] = htmlData?.markdown
    setViewResultsRequestDetails(data)
    setIsResultsLoading(false)
  }



  return (
    <SpaceBetween direction="vertical" size="m">
      {
        isResultsLoading && <StatusIndicator type="loading">
          Loading
        </StatusIndicator>
      }

      {
        !isResultsLoading && viewResultsRequestDetails && <Container header={<SpaceBetween direction="horizontal" size="m">
          <img
            className="ai-button"
            src={aiInsights}
            alt=""
          />
          <Box variant="awsui-key-label"> You are viewing results for Entity Name: {viewResultsRequestDetails?.entity_name || '-'}, Execution Date: {convertToLocalTime(viewResultsRequestDetails?.created_at, true) || '-'}, Current year: {viewResultsRequestDetails?.current_year || '-'}, Prior Year: {viewResultsRequestDetails?.previous_year || '-'} </Box>
        </SpaceBetween>}>
          {
             viewResultsRequestDetails?.markdownData && 
              <ReactMarkdown remarkPlugins={[remarkGfm]}
                components={{
                  table: ({ node, ...props }) => (
                    <div style={{ margin: '40px 0', overflowX: 'auto' }}>
                      <table
                        {...props}
                        style={{
                          borderCollapse: 'collapse',
                          width: '100%',
                        }}
                      />
                    </div>
                  ),
                  th: ({ node, ...props }) => (
                    <th
                      {...props}
                      style={{
                        padding: '5px 8px',
                        border: '1px solid #ddd',
                        backgroundColor: '#f5f5f5',
                        textAlign: 'left'
                      }}
                    />
                  ),
                  td: ({ node, ...props }) => (
                    <td
                      {...props}
                      style={{
                        padding: '5px 8px',
                        border: '1px solid #ddd',
                        textAlign: 'left'
                      }}
                    />
                  ),
                  tr: ({ node, ...props }) => (
                    <tr {...props} style={{ borderBottom: '1px solid #ddd' }} />
                  )
                }}

              >
                {viewResultsRequestDetails.markdownData}
              </ReactMarkdown>
              
          }

        </Container>
      }
    </SpaceBetween>

  );
};

export default FirstPassResultComponent;
